// export const baseurlvmkp='/vmkp/api'

export const baseurlvmkp='/vmkp/api'
export const baseexcel='/vmkp/'
export const loadingcherker = (value) => {
    return value ? value : false;
  };
